import { render, staticRenderFns } from "./IdLogout.vue?vue&type=template&id=9a1130f2&lang=pug&"
import script from "./IdLogout.vue?vue&type=script&lang=js&"
export * from "./IdLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports